import { DealComparatorSection } from '@/presentation/pages/public/Deal/components/DealComparatorSection';
import { Carousel, MediaQuery, Theme } from '@pelando/components';
import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 0;
  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0 24px 24px;
  }
`;

const listItemStyle = css`
  container-type: inline-size;
  cursor: pointer;
  min-width: 302px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const ListItem = styled(Carousel.ListItem)`
  ${listItemStyle}
`;

export const List = styled(Carousel.List)`
  && {
    gap: 12px;
    padding: 0 16px;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    && {
      gap: 24px;
      padding: 0;
    }

    &[data-has-few-deals='true'] {
      flex-wrap: unset;
      display: flex;
      gap: 24px;
      overflow: unset;

      li {
        width: 100%;
        flex-shrink: unset;
      }
    }
  }
`;

const hideOnMobileStyle = css`
  @media ${MediaQuery.SCREEN_SM} {
    display: none;
  }
`;

const indicatorStyle = css`
  i {
    color: rgb(${Theme.colors.Brand});
  }
  ${hideOnMobileStyle}
`;

export const NextIndicator = styled(Carousel.NextIndicator)`
  ${indicatorStyle}
`;

export const PrevIndicator = styled(Carousel.PrevIndicator)`
  ${indicatorStyle}
`;

export const HideTextOnMobile = styled.span`
  ${hideOnMobileStyle}
`;

export const HideTextOnDesktop = styled.span`
  @media ${MediaQuery.SCREEN_MD_UP} {
    display: none;
  }
`;

export const ComparatorSection = styled(DealComparatorSection)`
  grid-area: product;
  margin-bottom: 0;
  border-top: 4px solid rgb(${Theme.colors.Juliet});
  background-color: rgb(${Theme.colors.Kilo});

  @media ${MediaQuery.SCREEN_MD_UP} {
    background-color: rgb(${Theme.colors.Juliet});
    border-top: unset;
    margin-bottom: 24px;
  }
`;

export const SkeletonVisibilityControl = styled.div`
  display: contents;
`;
